import { TermsDataType } from '@/types/terms.type';

export const termsOfLocationData: TermsDataType[] = [
  {
    title: '위치정보 수집 이용에 대한 동의(필수)',
    lineBreak: true,
  },
  {
    discription1:
      '㈜애드락애드버테인먼트 (서울특별시 송파구 오금로 101, 8층) (이하 “회사”)가 제공하는 도로로 서비스(이하 “서비스”)와 관련하여, 회사가 아래의 내용과 같이 본인의 위치정보를 수집∙이용하는데 동의합니다.',
    lineBreak: true,
  },
  {
    title2: '제1조 목적',
    discription1:
      '본 약관은 회사가 제공하는 위치정보사업 또는 위치기반서비스에 대해 회사와 서비스 계약을 체결한 개인위치정보주체(이하 “고객”이라 합니다) 간의 권리·의무, 책임사항 및 기타 필요한 사항을 규정함을 목적으로 합니다. 고객은 이 약관에 동의함으로써 개인위치정보의 수집 및 이를 이용한 서비스 제공에 동의합니다.',
    lineBreak: true,
  },
  {
    title2: '제2조 약관 외 준칙',
    discription1:
      '본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 약관에 명시되지 않은 사항 및 용어의 정의는 위치정보의 보호 및 이용 등에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전기통신사업법 등 관련 법령과 회사의 서비스의 이용을 위한 서비스 이용약관, 개인정보처리방침 또는 상관례에 따릅니다.',
    lineBreak: true,
  },
  {
    title2: '제3조 약관의 효력 및 변경',
    discription2: [
      [
        '1.',
        '본 약관은 개인위치정보주체가 본 약관에 동의함으로써 효력이 발생합니다.',
      ],
      [
        '2.',
        '고객이 온라인에서 본 약관에 대한 동의 표시를 입력하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.',
      ],
      [
        '3.',
        '회사는 법률이나 위치기반서비스의 변경사항을 반영하기 위한 목적 등으로 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.',
      ],
      [
        '4.',
        '회사가 약관을 개정할 경우에는 개정약관의 적용일자 14일 전부터 도로로 서비스 홈페이지, 전자우편, 휴대폰 문자메시지 등을 이용하는 것 중 한가지 혹은 복수의 방법으로 고객에게 고지합니다.',
      ],
      [
        '5.',
        '회사가 전항에 따라 고객에게 고지하면서 개정약관 시행일까지 거부의사를 표시하지 아니하면 개정약관에 승인한 것으로 봅니다. 고객이 개정약관에 동의하지않을 경우 고객은 서비스 계약을 해지할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제4조 위치정보 수집 및 이용 방법',
    discription2: [
      [
        '1.',
        '회사는 차량에 장착되어 있는 GPS 장치를 통해 개인위치정보주체가 운행하는 차량의 위치 정보를 검색하고, 차량에 장착되어 있는 이동통신식별장치(이하 ‘SIM’이라 함)를 통해 검색한 정보를 수집합니다.',
      ],
      [
        '2.',
        '회사는 제1항에 따라 수집한 차량의 위치정보 및 개인위치정보주체가 사용하는 스마트폰 등 단말장치의 OS 사업자로부터 제공받는 단말장치의 위치정보를 이용하여 본건 서비스를 제공합니다.',
      ],
      [
        '3.',
        '본건 서비스는 차량의 운전자에게 제공되는 서비스로서 차량을 운전할 수 있는 적법한 자격을 갖추지 못한 자는 본건 서비스를 이용할 수 없으며, 14세 미만 아동의 위치정보는 수집∙이용∙제공되지 않습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제5조 위치기반서비스의 내용',
    discription2: [
      [
        '1.',
        '회사는 수집한 고객의 현재 위치 또는 현재 위치가 포함된 지역을 이용하여 아래와 같은 서비스를 제공합니다.',
      ],
    ],
    discription3: [
      [
        '①',
        '운전연수 서비스 : 이용자의 위치를 바탕으로 가까운 운전연수 서비스 지점 혹은 강사의 정보를 제공하고 운전연수 과정에서 주행한 경로와 주행시간 데이터 등을 활용한 다양한 응용서비스',
      ],
      [
        '②',
        '내비게이션 및 인포테인먼트 서비스: 차량의 현재 위치를 바탕으로 주변의 주차장, 주유소, 충전소 등의 정보를 제공하고, 주변시설 검색 및 경로탐색과 같은 기능이나, 운행통계정보, 도착예상시간과 같이 위치정보를 이용한 다양한 정보를 제공하는 응용서비스 (이용자의 단말기기의 위치정보를 이용하여 출발지에서 목적지에 이르는 확장된 형태의 내비게이션 기능 포함)',
      ],
      [
        '③',
        '차량 부가 서비스: 차량의 주∙정차 위치나 운행위치를 파악하여 이용자에게 알려주거나, 원격으로 문 잠금/잠금해제, 헤드라이트 조작 등의 기능을 제공하는 등 다양한 형태의 응용서비스',
      ],
      [
        '④',
        '고객 지원 서비스: 이용자의 위치를 기반으로 이용자의 유선 문의나 요청에 대해 적절한 응대를 제공하며, 특정 위치를 바탕으로 각종 정보제공, 추천, 예약 등 다양한 편의를 제공하는 서비스',
      ],
      [
        '⑤',
        '회사가 차량의 이용자에게 편의를 제공할 목적으로 차량의 위치정보 및 이용자 단말기기의 위치정보를 활용하여 개발∙제공하는 기타 위치기반서비스',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제6조 서비스 이용요금',
    discription1:
      '회사가 제공하는 위치기반서비스는 이용항목에 따라 유료일 수 있으며, 유료 서비스 경우 해당 서비스에 명시된 요금을 지불하여야 사용 가능합니다.',
    lineBreak: true,
  },
  {
    title2: '제7조 서비스의 변경 및 중지',
    discription2: [
      [
        '1.',
        '회사는 위치정보사업자의 정책변경 등과 같이 회사의 제반 사정 또는 법률상의 이유로 서비스를 유지할 수 없는 경우, 서비스의 전부 또는 일부를 제한, 변경 또는 중지할 수 있습니다.',
      ],
      [
        '2.',
        '제1항에 의한 서비스 중단의 경우 회사는 사전에 회사의 홈페이지 등을 통해 공지하거나 고객의 등록된 정보를 토대로 전자우편을 통하여 고객에게 통지합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제8조 위치정보의 제공에 대한 동의',
    discription2: [
      [
        '1.',
        '회사는 개인위치정보를 개인위치정보주체가 지정하는 제3자에게 제공하는 서비스를 제공하지 않습니다. 다만, 향후에 이러한 서비스를 제공하려는 경우 관련된 사항을 본 약관에 명시하여 개인위치정보주체에게 고지하고 동의를 얻습니다.',
      ],
      [
        '2.',
        '전항 단서에 따른 서비스를 제공하는 경우 회사는 매회 개인위치정보주체에게 개인위치정보를 제공받는 자, 제공일시 및 제공목적을 즉시 통보하거나, 개인위치정보주체의 동의를 받아 횟수나 기간을 정하여 제공 내역을 모아서 통보합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제9조 위치정보 수집·이용·제공사실 확인자료의 보유',
    discription2: [
      [
        '1.',
        '회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 개인위치정보주체의 위치정보 수집·이용·제공사실 확인자료를 위치정보시스템에 자동으로 기록하며, 해당 자료는 기록시점으로부터 고객불만 응대 등을 위하여 6개월간 보관합니다.',
      ],
      [
        '2.',
        '회사는 본 약관 제5조(위치기반서비스의 내용)에 따른 고객의 개인 위치 정보의 수집 목적을 달성하거나, 고객이 개인 위치 정보의 수집에 대한 동의의 전부 또는 일부에 대하여 철회한 시점에는 개인 위치 정보를 지체 없이 파기합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제10조 개인위치정보주체의 권리와 행사방법',
    discription2: [
      [
        '1.',
        '개인위치정보주체는 언제든지 개인위치정보 수 집∙이용∙제공에 관한 동의를 전부 또는 일부 철회할 있으며, 언제든지 개인위치정보 수집∙이용∙제 공의 일시적인 중지를 요구할 수 있습니다. 다만, 이러한 경우 본건 서비스의 전부 또는 일부의 이용이 제한될 수 있습니다.',
      ],
      [
        '2.',
        '개인위치정보주체는 본인에 대한 위치정보 수집∙이용∙제공사실 확인자료 및 본인의 개인위치정 보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률의 규정에 의하여 제3자에게 제공된 이유 및 내용에 대해 열람 또는 고지를 요구할 수 있고, 해당 자료 등에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.',
      ],
      [
        '3.',
        '개인위치정보주체는 고객지원센터(02-599-1408, help@adrock.me)에 연락을 하여 언제든지 위 각 항에 따른 권리를 행사할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제11조 개인위치정보의 보유목적 및 이용기간',
    discription2: [
      [
        '1.',
        '회사는 본건 서비스를 제공하고 관련 법령을 준수하며 기타 개인위치정보주체가 동의한 목적을 위해 개인위치정보를 보유합니다.',
      ],
      [
        '2.',
        '회사는 개인위치정보주체가 본건 서비스를 이용하기 위해 회원으로 가입한 기간 동안 해당 개인위치정보주체의 개인위치정보를 이용합니다. 단, 관련 법령에 따라 개인위치정보를 보존할 의무가 있는 때에는 해당 법령에서 정하는 기간 동안 개인위치정보를 보유합니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제12조 법정대리인 및 보호의무자의 권리',
    discription2: [
      [
        '1.',
        '본 서비스는 차량의 운전자에게 제공되는 서비스로서 차량을 운전할 수 있는 적법한 자격을 갖추지 못한 자는 본 서비스를 이용할 수 없으며, 다음과 같은 14세 미만의 아동 등의 개인위치정보는 수집·이용·제공하지 않습니다.',
      ],
    ],
    discription3: [
      ['①', '위치정보법에 따라 법정대리인의 동의가 필요한 14세 미만의 아동'],
      [
        '②',
        '위치정보법에 따라 보호의무자의 동의가 필요한 8세 이하의 아동, 피성년후견인, 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)',
      ],
    ],
  },
  {
    discription2: [
      [
        '2.',
        '제1항에도 불구하고 회사가 14세 미만의 아동 등에 대한 개인위치정보를 처리해야 할 경우, 회사는 법률에 따라 법정대리인 혹은 보호의무자의 동의를 받아야 합니다. 이 경우 법정대리인 혹은 보호의무자는 제10조에 의한 고객의 권리를 모두 가집니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제13조 손해배상',
    discription2: [
      [
        '1.',
        '회사가 위치정보법 제15조 내지 제26조의 규정을 위반한 행위로 고객에게 손해가 발생한 경우 고객은 회사에 대하여 손해배상 청구를 할 수 있습니다. 이 경우 회사는 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.',
      ],
      [
        '2.',
        '고객이 본 약관의 규정을 위반하여 회사에 손해가 발생한 경우 회사는 고객에 대하여 손해배상을 청구할 수 있습니다. 이 경우 고객은 고의, 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.',
      ],
      [
        '3.',
        '기타 손해배상 혹은 면책에 대해서는 회사의 서비스 이용약관을 따릅니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제14조 분쟁의 조정',
    discription2: [
      [
        '1.',
        '회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 위치정보법 제28조의 규정에 의한 방송통신위원회에 재정을 신청할 수 있습니다.',
      ],
      [
        '2.',
        '회사 또는 고객은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 개인정보 보호법 제43조의 규정에 의한 개인정보 분쟁조정위원회에 조정을 신청할 수 있습니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title2: '제15조 사업자 정보',
    discription1: '회사의 상호, 주소, 전화번호는 다음과 같습니다.',
    discription2: [
      ['-', '상호: 주식회사 애드락애드버테인먼트'],
      ['-', '대표자: 방규선'],
      ['-', '주소: 서울특별시 송파구 오금로 101, 8층'],
      ['-', '전화번호: 02-599-1408'],
    ],
    lineBreak: true,
  },
  {
    title2: '제16조 위치정보 관리 책임자',
    discription1:
      '회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다. 회사가 지정한 위치정보관리책임자는 다음과 같습니다.',
    discription2: [
      ['-', '성명/소속: 오채윤 팀장 / 사업전략팀'],
      ['-', '전화번호: 070-4323-2968'],
      ['-', '전자우편주소: pm@adrock.me'],
    ],
    lineBreak: true,
  },
  {
    discription1:
      '\n부 칙 (시행일)\n\n' + '이 약관은 2025년 01월 20일부터 시행합니다.',
    lineBreak: true,
  },
];
